import useSWR from 'swr';
import { Feed, SearchPaginatedQuery } from '@bpm-web-app/api-client';

/**
 * Your Feed — server-paginated new releases from the current user's followed artists
 */
export function useFeed(query: SearchPaginatedQuery, enabled = true) {
    const { data, error, mutate } = useSWR(
        enabled ? ['feed', { ...query }] : null,
        () => Feed.getFeed(query),
        { shouldRetryOnError: true, errorRetryCount: 3, errorRetryInterval: 2000 }
    );

    return {
        data,
        mutate,
        isLoading: enabled && !error && !data,
        error,
    };
}
